var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3050,
    height: 102,
    viewBox: "0 0 3050 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3604",
    "data-name": "Group 3604",
    transform: "translate(-495 -1316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WAVES_03",
    "data-name": "WAVES 03",
    transform: "translate(495 1316)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8772",
    "data-name": "Path 8772",
    d: "M836.613,431.234c-20.951,7.943-47.411,12.684-76.175,12.684s-55.222-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.173,12.684s-55.224-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.175,12.684s-55.222-4.741-76.173-12.684c-20.951,7.943-47.411,12.684-76.175,12.684s-55.222-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.173,12.684s-55.93-4.741-76.881-12.684c-.816,7.766,0,95.8,0,95.8l765.788,7.417S843.255,449.776,836.613,431.234Z",
    transform: "translate(-74.116 -426.289)",
    fill: "#38c5cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8778",
    "data-name": "Path 8778",
    d: "M836.613,431.234c-20.951,7.943-47.411,12.684-76.175,12.684s-55.222-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.173,12.684s-55.224-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.175,12.684s-55.222-4.741-76.173-12.684c-20.951,7.943-47.411,12.684-76.175,12.684s-55.222-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.173,12.684s-55.93-4.741-76.881-12.684c-.816,7.766,0,104.732,0,104.732l762.452-1.2S843.255,449.776,836.613,431.234Z",
    transform: "translate(688.384 -426.289)",
    fill: "#38c5cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "MASQUE-3",
    "data-name": "MASQUE",
    width: 1525,
    height: 102,
    transform: "translate(207.728 -194)",
    fill: "#38c5cf",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "WAVES_03-2",
    "data-name": "WAVES 03",
    transform: "translate(2020 1316)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8900",
    "data-name": "Path 8900",
    d: "M836.613,431.234c-20.951,7.943-47.411,12.684-76.175,12.684s-55.222-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.173,12.684s-55.224-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.175,12.684s-55.222-4.741-76.173-12.684c-20.951,7.943-47.411,12.684-76.175,12.684s-55.222-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.173,12.684s-55.93-4.741-76.881-12.684c-.816,7.766,0,95.8,0,95.8l765.788,7.417S843.255,449.776,836.613,431.234Z",
    transform: "translate(-74.116 -426.289)",
    fill: "#38c5cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8901",
    "data-name": "Path 8901",
    d: "M836.613,431.234c-20.951,7.943-47.411,12.684-76.175,12.684s-55.222-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.173,12.684s-55.224-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.175,12.684s-55.222-4.741-76.173-12.684c-20.951,7.943-47.411,12.684-76.175,12.684s-55.222-4.741-76.175-12.684c-20.951,7.943-47.409,12.684-76.173,12.684s-55.93-4.741-76.881-12.684c-.816,7.766,0,104.732,0,104.732l762.452-1.2S843.255,449.776,836.613,431.234Z",
    transform: "translate(688.384 -426.289)",
    fill: "#38c5cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "MASQUE-4",
    "data-name": "MASQUE",
    width: 1525,
    height: 102,
    transform: "translate(207.728 -194)",
    fill: "#38c5cf",
    opacity: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave3);
export default __webpack_public_path__ + "static/media/wave3.20ac3927.svg";
export { ForwardRef as ReactComponent };